/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Custom_Properties_Create_HiddenInputs */

const en_forms_custom_properties_create_hidden = /** @type {(inputs: Forms_Custom_Properties_Create_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hidden`)
};

const de_forms_custom_properties_create_hidden = /** @type {(inputs: Forms_Custom_Properties_Create_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist ausgeblendet`)
};

/**
* | output |
* | --- |
* | "Hidden" |
*
* @param {Forms_Custom_Properties_Create_HiddenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_custom_properties_create_hidden = /** @type {((inputs?: Forms_Custom_Properties_Create_HiddenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Custom_Properties_Create_HiddenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_custom_properties_create_hidden(inputs)
	return de_forms_custom_properties_create_hidden(inputs)
});